import React from 'react';
import { Logo } from './Logo';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-[rgba(0,0,0,0.1)] py-4">
        <div className="container flex items-center justify-between">
          <Link to="/">
            <Logo size="small" />
          </Link>
          <Link to="/" className="flex items-center gap-2 text-[rgb(131,146,140)] hover:text-[rgb(0,55,32)] transition-colors">
            <ArrowLeft size={18} />
            <span>Torna alla Home</span>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container py-12 max-w-4xl">
        <h1 className="heading-1 mb-8">Privacy Policy</h1>
        <p className="text-[rgb(131,146,140)] mb-8">Ultimo aggiornamento: Gennaio 2025</p>

        <div className="prose prose-lg max-w-none text-[rgb(14,15,12)]">
          <section className="mb-8">
            <h2 className="heading-3 mb-4">1. Introduzione</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              EZVI ("noi", "nostro" o "la Società") si impegna a proteggere la privacy dei propri utenti. 
              Questa Privacy Policy descrive come raccogliamo, utilizziamo e proteggiamo le informazioni personali 
              quando utilizzi la nostra applicazione mobile e il sito web ezvi.it.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">2. Dati Raccolti</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">Raccogliamo i seguenti tipi di informazioni:</p>
            <ul className="list-disc pl-6 space-y-2 text-[rgb(131,146,140)]">
              <li><strong>Dati di localizzazione:</strong> Per mostrarti le colonnine di ricarica nelle vicinanze</li>
              <li><strong>Dati di utilizzo:</strong> Come interagisci con l'app per migliorare il servizio</li>
              <li><strong>Informazioni sul dispositivo:</strong> Tipo di dispositivo, sistema operativo</li>
              <li><strong>Preferenze:</strong> Tipo di connettore, operatori preferiti</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">3. Come Utilizziamo i Dati</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">Utilizziamo i tuoi dati per:</p>
            <ul className="list-disc pl-6 space-y-2 text-[rgb(131,146,140)]">
              <li>Fornirti il servizio di confronto prezzi delle colonnine</li>
              <li>Personalizzare la tua esperienza nell'app</li>
              <li>Migliorare e ottimizzare i nostri servizi</li>
              <li>Inviarti notifiche relative al servizio (se autorizzato)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">4. Condivisione dei Dati</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Non vendiamo mai i tuoi dati personali a terzi. Potremmo condividere dati aggregati e anonimi 
              con i nostri partner per migliorare il servizio.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">5. I Tuoi Diritti</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Ai sensi del GDPR, hai il diritto di:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-[rgb(131,146,140)]">
              <li>Accedere ai tuoi dati personali</li>
              <li>Rettificare dati inesatti</li>
              <li>Richiedere la cancellazione dei tuoi dati</li>
              <li>Opporti al trattamento dei dati</li>
              <li>Portabilità dei dati</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">6. Sicurezza</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Implementiamo misure di sicurezza tecniche e organizzative per proteggere i tuoi dati 
              da accessi non autorizzati, perdita o distruzione.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="heading-3 mb-4">7. Contatti</h2>
            <p className="body-medium text-[rgb(131,146,140)] mb-4">
              Per qualsiasi domanda relativa alla privacy, contattaci all'indirizzo: 
              <a href="mailto:privacy@ezvi.it" className="text-[rgb(13,121,22)] hover:underline">privacy@ezvi.it</a>
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
